import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react'

type PlayHandler = (game: unknown) => void

type CasinoUiContextValue = {
  playGame: (game: unknown) => void
  registerPlayHandler: (handler: PlayHandler | null) => void
}

const CasinoUiContext = createContext<CasinoUiContextValue | null>(null)

export const CasinoUiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const handlerRef = useRef<PlayHandler | null>(null)

  const registerPlayHandler = useCallback((handler: PlayHandler | null) => {
    handlerRef.current = handler
  }, [])

  const playGame = useCallback((game: unknown) => {
    handlerRef.current?.(game)
  }, [])

  const value = useMemo(
    () => ({ playGame, registerPlayHandler }),
    [playGame, registerPlayHandler],
  )

  return <CasinoUiContext.Provider value={value}>{children}</CasinoUiContext.Provider>
}

export function useCasinoUi() {
  const ctx = useContext(CasinoUiContext)
  if (!ctx) {
    return {
      playGame: () => {},
      registerPlayHandler: () => {},
    }
  }
  return ctx
}
